import { CALL_API } from '../../api';
import * as ActionTypes from './prize.actionTypes';
import schema from '../../api/schema';

const readPrizes = () => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_PRIZES_REQUEST,
      ActionTypes.READ_PRIZES_SUCCESS,
      ActionTypes.READ_PRIZES_FAILURE,
    ],
    endpoint: 'api/prize',
    schema: schema.prizesSchema,
    authorization: true,
  }
});

export const getPrizes = () => (dispatch, getState) => {
  return dispatch(readPrizes());
};

const readPrize = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_PRIZE_REQUEST,
      ActionTypes.READ_PRIZE_SUCCESS,
      ActionTypes.READ_PRIZE_FAILURE,
    ],
    endpoint: `api/prize/${id}`,
    schema: schema.prizeSchema,
    authorization: true,
  },
  payload: {
    id
  }
});

export const getPrize = (id) => (dispatch, getState) => {
  const prize = getState().entities.prize.byId[id];
  if (prize) {
    return Promise.resolve();
  }
  return dispatch(readPrize(id));
};

const doCreatePrize = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.CREATE_PRIZE_REQUEST,
      ActionTypes.CREATE_PRIZE_SUCCESS,
      ActionTypes.CREATE_PRIZE_FAILURE,
    ],
    endpoint: 'api/prize/',
    schema: schema.prizeSchema,
    authorization: true,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  }
});

export const createPrize = (data) => (dispatch, getState) => {
  return dispatch(doCreatePrize(data));
};

const doUpdatePrize = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.UPDATE_PRIZE_REQUEST,
      ActionTypes.UPDATE_PRIZE_SUCCESS,
      ActionTypes.UPDATE_PRIZE_FAILURE,
    ],
    endpoint: `api/prize/${data._id}`,
    schema: schema.prizeSchema,
    authorization: true,
    requestInit: {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  },
  payload: {
    id: data._id
  }
});

export const updatePrize = (data) => (dispatch, getState) => {
  return dispatch(doUpdatePrize(data));
};

const doDeletePrize = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.DELETE_PRIZE_REQUEST,
      ActionTypes.DELETE_PRIZE_SUCCESS,
      ActionTypes.DELETE_PRIZE_FAILURE,
    ],
    endpoint: `api/prize/${id}`,
    schema: schema.prizeSchema,
    authorization: true,
    requestInit: {
      method: 'DELETE',
    },
  },
  payload: {
    id
  }
});

export const deletePrize = (id) => (dispatch, getState) => {
  return dispatch(doDeletePrize(id));
};


// WEBPACK FOOTER //
// ./src/modules/prize/prize.actions.js